<template>
  <el-dialog
    title="修改币种划转介配置"
    width="40%"
    :visible.sync="detailDialogVisible"
    @close="closeDialog"
    @open="openDialog"
    :before-close="handleClose"
  >
    <el-form
      label-width="190px"
      :model="detailData"
      :rules="rules"
      ref="currencyTransferForm"
    >
      <!-- <el-form-item label="币种名称：" prop="coinName">
          <el-input v-model="introduction.coinName"></el-input>
        </el-form-item> -->
      <el-form-item label="id：" prop="id">
        <el-input
          v-model="detailData.id"
          disabled
          style="width: 222px"
        ></el-input>
      </el-form-item>
      <el-form-item label="币种：" prop="coin">
        <el-input v-model="detailData.coin" style="width: 222px"></el-input>
      </el-form-item>

      <el-form-item label="出钱包类型：" prop="fromType">
        <el-select v-model="detailData.fromType" placeholder="请选择">
          <el-option
            v-for="item in datas"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="入钱包类型：" prop="toType">
        <el-select v-model="detailData.toType" placeholder="请选择">
          <el-option
            v-for="item in datas"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="租户选择：" prop="tenantId">
        <el-select
          disabled
          v-model="pairTransfer.tenantId"
          placeholder="租户选择"
          clearable
        >
          <el-option
            v-for="item in tenantList"
            :key="item.id"
            :label="item.tenantName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="划转开关：" prop="isTransfer">
        <el-switch
          v-model="detailData.isTransfer"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSave('currencyTransferForm')"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Editor from "components/editor";
import LANGUAGES from "common/languages";
import { tenantInfo } from "@/common/publicApi";
export default {
  name: "CurrencyIntroductionDetail",
  props: ["id", "val"],
  data() {
    return {
      detailData: {},
      tenantList: [],
      languages: Object.keys(LANGUAGES).map((lang) => ({
        label: LANGUAGES[lang],
        value: lang,
      })),
      options: [
        {
          value: "SPOT",
          label: "SPOT",
        },
        {
          value: "CONTRACT",
          label: "CONTRACT",
        },
      ],
      rules: {
        coin: [{ required: true, message: "请输入币种名称" }],
        fromType: [{ required: true, message: "请输入币种名称" }],
        toType: [{ required: true, message: "请输入币种名称" }],
        isTransfer: [{ required: true, message: "请输入币种名称" }],
      },
    };
  },

  computed: {
    ...mapState("currencyTransferSetting", [
      "detailDialogVisible",
      "introductionDetail",
      "datas",
    ]),
  },
  components: {
    Editor,
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
  },
  methods: {
    ...mapActions("currencyTransferSetting", [
      "update",
      "detail",
      "updateOrAdd",
    ]),
    ...mapMutations("currencyTransferSetting", [
      "toggleDetailDialogVisible",
      "setIntroductionDetail",
    ]),
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          this.detail = {};
        })
        .catch((_) => {});
    },

    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        let updateId = this.detailData;
        if (valid) {
          this.updateOrAdd({
            ...updateId,
          }).then((res) => {
            this.$message.success("修改成功！");
            this.toggleDetailDialogVisible(false);
            this.detailData = {};
            this.$emit("refresh");
          });
        }
      });
    },
    handleCancel() {
      this.toggleDetailDialogVisible(false);
      this.detailData = {};
    },
    handleChange(key, value) {
      this.setIntroductionDetail({
        ...this.introductionDetail,
      });
    },
    handleEditorChange(type, key, value) {
      this.setIntroductionDetail({
        ...this.introductionDetail,
        [type]: {
          ...this.introductionDetail[type],
          [key]: value,
        },
      });
    },
    openDialog() {
      this.detailData = this.val;
    },
    closeDialog() {
      this.detailData = {};
      this.toggleDetailDialogVisible(false);
      // this.setIntroductionDetail({});
      this.$refs["currencyTransferForm"].resetFields();
    },
  },
};
</script>

<style lang="less" scoped></style>
